// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 9V3H1V9L23 9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 11.0004V21L1 21V11.0004H23ZM9 17.0001V15.0001L4 15.0001L4 17.0001L9 17.0001Z"}}]};

const CreditcardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard-filled',
    ref,
    icon: element,
  },
));

CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';

export default CreditcardFilledIcon;
